import ImpactsOnStakeholdersCheckAll from './ImpactsOnStakeholdersCheckAll';

export default ImpactsOnStakeholdersCheckAll;
